import { apiClient } from '@/lib/api'
import { Deal, DealStage } from '@/types/deal'

export type DealWriteBody = {
  title: string
  // Base price of the boat/deal itself; add-on lines are itemized separately
  // and rolled into the deal's value server-side.
  base_value: number
  stage: DealStage
  owner: string
  customer_id: string
  boat_id?: string // empty/undefined clears the link
  expected_close?: string
}

export const fetchDeals = async (q?: string, stage?: string): Promise<Deal[]> => {
  const params: Record<string, string> = {}
  if (q) params.q = q
  if (stage) params.stage = stage
  return apiClient<Deal[]>('/deals', {
    params: Object.keys(params).length > 0 ? params : undefined,
  })
}

export const fetchDeal = async (id: string): Promise<Deal> => apiClient<Deal>(`/deals/${id}`)

export const createDeal = async (body: DealWriteBody): Promise<Deal> =>
  apiClient<Deal>('/deals', { method: 'POST', body })

export const updateDeal = async (id: string, body: DealWriteBody): Promise<Deal> =>
  apiClient<Deal>(`/deals/${id}`, { method: 'PUT', body })

export const deleteDeal = async (id: string): Promise<void> =>
  apiClient<void>(`/deals/${id}`, { method: 'DELETE' })
